import React from 'react';
import {Helmet} from 'react-helmet-async';

const siteUrl = 'https://barberadelvalles.bar';
const socialImage = 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1780387072305-social-share.jpeg';

const organizationSchema = {
  '@type': 'Organization',
  '@id': `${siteUrl}/#organization`,
  name: 'The Selection Barberà',
  url: siteUrl,
  description: 'An independent directory of the best bars, restaurants, craft beer venues, and nightlife in Barberà del Vallès.'
};

const websiteSchema = {
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  name: 'The Selection Barberà',
  url: siteUrl,
  description: 'Discover the best bars, restaurants, craft beer, tapas, cocktails, breakfasts, and pints in Barberà del Vallès.',
  publisher: {
    '@id': `${siteUrl}/#organization`
  },
  inLanguage: ['en', 'es']
};

const getPageSchema = (schema) => {
  if (!schema) {
    return null;
  }

  if (typeof schema === 'string') {
    try {
      return JSON.parse(schema);
    } catch {
      return null;
    }
  }

  return schema;
};

const SEO = ({title, description, schema}) => {
  const currentUrl = typeof window !== 'undefined'
    ? window.location.href
    : siteUrl;
  const pageSchema = getPageSchema(schema);
  const graph = [organizationSchema, websiteSchema];

  if (pageSchema && typeof pageSchema === 'object') {
    graph.push(pageSchema);
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': graph
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={currentUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:site_name" content="Barberà del Vallès Bar Directory" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;